import axios from 'axios'

export default {
  methods: {
    sendDeviceToken(token, type) {
      const params = {
        device: { platform: type, token: token },
      }
      axios({
        method: 'post',
        url: 'devices',
        data: params,
      })
        .then(response => {
          console.log('sendDeviceToken response', response)
        })
        .catch(error => {
          console.error('sendDeviceToken error', error)
        })
    },
  },
}
